export default __webpack_public_path__ + "static/media/studentRealCase2-mobile-sc.c1e17ca7.jpg";